const TextBlock = ({ data }) => {
  const { texto, color } = data
  return (
    <div
      style={{
        backgroundColor: color
      }}
      className="font-alliance-medium text-[24px] lg:text-[48px] text-blue p-20 leading-tight"
    >
      {texto}
    </div>
  )
}
export default TextBlock
